var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 4C8.10108 4 4.5 7.58662 4.5 11.9976V12.5954H5.73411V11.9976C5.73411 8.2567 8.76635 5.23411 12.5217 5.23411C14.5368 5.23411 16.3349 6.1163 17.5738 7.50467L16.1806 8.89304H20.5434V4.54474L18.4464 6.63212C16.9809 5.02199 14.8742 4 12.5217 4ZM19.3093 11.3613V11.9783C19.3093 15.7337 16.277 18.7659 12.5217 18.7659C10.497 18.7659 8.69886 17.8741 7.45511 16.4712L8.86276 15.0636H4.5V19.4263L6.58256 17.3438C8.05288 18.9684 10.1644 20 12.5217 20C16.9471 20 20.5434 16.4037 20.5434 11.9783V11.3613H19.3093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.d3d3cdd4dd9dc2c65b57abd870020389.svg";
export { ForwardRef as ReactComponent };